import { WebsocketMessage } from '@fastre/core/schemas/websocket'
import { useAuth } from 'auth'
import { useOrgId } from 'helpers'
import { createContext, useContext, useEffect, useState } from 'react'
import * as reactUseWebsocket from 'react-use-websocket'

const GeneralWebsocketContext = createContext<WebsocketMessage | null>(null)

export const GeneralWebsocketProvider = ({ children }) => {
    const orgId = useOrgId()
    const { token } = useAuth()

    const { lastMessage } = reactUseWebsocket.default(
        `${import.meta.env.VITE_APP_WEBSOCKET_URL}?orgId=${orgId}&token=${token}`,
        {
            heartbeat: true,
            shouldReconnect: closeEvent => true,
            //protocols: [token],
        },
    )

    const [newMessage, setNewMessage] = useState<WebsocketMessage | null>(null)

    useEffect(() => {
        if (lastMessage) {
            const data = JSON.parse(lastMessage.data)
            console.log('new message', data)
            setNewMessage(data)
        }
    }, [lastMessage])

    return <GeneralWebsocketContext.Provider value={newMessage}>{children}</GeneralWebsocketContext.Provider>
}

const useGeneralWebSocket = () => useContext(GeneralWebsocketContext)

export function useWebSocket(type: WebsocketMessage['type'] | undefined) {
    const [newMessage, setNewMessage] = useState<WebsocketMessage['payload'] | null>(null)

    const lastMessage = useGeneralWebSocket()

    useEffect(() => {
        if (lastMessage) {
            if (lastMessage.type == type) {
                setNewMessage(lastMessage.payload)
            }
        }
    }, [lastMessage])

    return newMessage
}
